export default __webpack_public_path__ + "static/leonie_bw-39a9d4f43535aeaba107fdc45d0d346c.jpeg";